import PropertySet from '@exp/exp-utils/helper/property';

const _experiments = new PropertySet();

export default _experiments;
